module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.ttf?279f38601f1d1655255f21db0691ab37";